<template>
  <div>
    <div class="mgt-20px">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getTitle }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button is-error" @click="retour">
              {{ $t('general.button.cancel') }}
            </button>
            <button class="button is-addOrEdit" @click="saveEmplacement">
              {{ $t('general.button.sauvegarder') }}
            </button>
            <button class="button"
                    @click="showAddAttachmentModal()">
              <b-icon icon="paperclip" type="is-default"></b-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="tab mgh-0">
        <ul>
          <li :class="{'is-active': activeTab === 'InfoGenerale'}"
            @click="activeTab = 'InfoGenerale'">
            {{ $t('ligneBusEmplacement.infoGeneral') }}
          </li>
          <li :class="{'is-active': activeTab === 'InfoTechnique'}"
            @click="activeTab = 'InfoTechnique'">
            {{ $t('ligneBusEmplacement.infoTechnique') }}
          </li>
        </ul>
      </div>
      <error-msg-component :messages="messages"
                          :error="error"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          :title="'editionClient.problemOccurred'"
                          :withEmplyFields="true"
                          @close="error = $event"
      />
      <div>
        <component
          :is="activeTab"
          :emplacement="emplacement"
          :emplacementTechniqueInformation="emplacement.emplacementTechnique"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererEmplacementLigneBus from '@/services/gabed/emplacement/ligneBus/genererEmplacementLigneBus';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import translate from '@/services/gabed/emplacement/validation/champsEmplacementTranslator';
import validationGeneral from '@/services/validation/validation';
import validationPatrimoine from '@/services/gabed/patrimoine/validationPatrimoine';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import { create, get, update } from '@/api/gabed/emplacement/emplacementLigneBus';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import InfoGenerale from '@/components/gabed/emplacement/ligneBus/m_infoGenerale';
import InfoTechnique from '@/components/emplacementTechnique/m_infoTechnique';
import breadcrumb from '@/components/general/breadcrumb';

const Attachments = createNamespacedHelpers('attachments');
const societe = createNamespacedHelpers('societe');

export default {
  name: 'm_emplacementLigneBus',
  data() {
    return {
      activeTab: 'InfoGenerale',
      emplacement: genererEmplacementLigneBus(),
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      permEmplacement: EMPLACEMENT,
      code: '',
      prevRoute: null,
    };
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      showAddAttachmentModal: 'showAddModal',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    loadError(response) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      validationGeneral(this.$i18n, response, this.champsVide, this.messages,
        this.messagesChampsVide, translate);
      validationPatrimoine(response, this.messages);
      this.error = true;
    },
    async retour() {
      if (this.prevRoute?.name === 'm.gabed.emplacement-ajoutEmplacement') {
        await this.$router.replace({ name: 'm.gabed.emplacement-ajoutEmplacement' });
      } else {
        await this.$router.go(-1);
      }
    },
    async saveEmplacement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        if (this.emplacement.entiteCommerciale.entiteCommercialeLigneBus.nbBusCirculant === '') {
          this.emplacement.entiteCommerciale.entiteCommercialeLigneBus.nbBusCirculant = null;
        }
        let ligneBus;
        if (this.$route.params.id) {
          ligneBus = (await update(this.emplacement)).data.result;
          await this.updateAttachments(this.emplacement.id);
          messageSucces(this.$t('ligneBusEmplacement.save'));
        } else {
          this.emplacement.societeId = this.societeActiveId;
          ligneBus = (await create(this.emplacement)).data.result;
          await this.setAttachmentElementId({ id: ligneBus.id });
          await this.insertAttachments(ligneBus.id);
          messageSucces(this.$t('ligneBusEmplacement.success'));
        }
        loadingComponent.close();
        if (this.prevRoute?.name === 'm.gabed.emplacement-ajoutEmplacement') {
          await this.$router.replace({
            name: 'c.gabed.emplacement-ligneBus',
            params: { id: ligneBus.id },
          });
        } else {
          this.$router.go(-1);
        }
      } catch (e) {
        if (e.response.data.error) {
          this.loadError(e.response);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw (e);
      }
    },
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeClients.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('emplacement.title'), route: { name: 'l.gabed.emplacement' }, isActive: false },
        {
          title: this.$i18n.t('detailEmplacement.titleWithoutN'),
          route: { name: 'c.gabed.emplacement-detailEmplacement', params: { id: this.$route.params.id } },
          isActive: false,
        },
        { title: this.$i18n.t('detailEmplacement.types.ligneBus'), route: '', isActive: true },
      ];
      if (!this.$route.params.id) {
        output.splice(2, 1);
      }
      return output;
    },
    getTitle() {
      return this.$route.params.id ? this.$i18n.t('ligneBusEmplacement.titleModification',
        { code: this.code }) : this.$i18n.t('ligneBusEmplacement.title');
    },
  },
  components: {
    appBreadcrumb: breadcrumb,
    errorMsgComponent,
    InfoTechnique,
    InfoGenerale,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'EmplacementLigneBus' });
      if (this.$route.params.id) {
        this.emplacement = (await get(this.$route.params.id)).data.result;
        this.code = cloneDeep(this.emplacement.code);
        await this.setAttachmentElementId({ id: this.emplacement.id });
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.emplacement.code }));
      } else this.setInformationPage(this.$t('pagePatrimoine.emplacement.ligneBus.creation'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
